import React, { useState } from 'react';
import { Menu, X } from 'lucide-react';
import { Link, useLocation } from 'react-router-dom';
const navLinks = [{
  label: 'Modern Commerce',
  href: '/modern-commerce'
}, {
  label: 'Apps Division',
  href: '/apps-division'
}, {
  label: 'About',
  href: '/about'
}, {
  label: 'Careers',
  href: '/careers'
}, {
  label: 'Contact',
  href: '/contact'
}];
export function Header() {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const location = useLocation();
  return <header className="sticky top-0 z-50 bg-[#F2F4F0] border-b border-border" data-id="element-37">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-38">
        <div className="flex items-center justify-between h-16 md:h-18" data-id="element-39">
          {/* Logo */}
          <Link to="/" className="flex items-center" data-id="element-40">
            <img src="https://assets.cru.io/cru-logo-primary.png" alt="CRU" className="h-12 hover:opacity-80 transition-opacity" data-id="element-41" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-42">
            {navLinks.map(link => {
            const isActive = location.pathname === link.href;
            return <Link key={link.label} to={link.href} className={`font-sans text-base transition-colors ${isActive ? 'text-primary font-semibold' : 'text-text hover:text-primary'}`} data-id="element-43">
                  {link.label}
                </Link>;
          })}
          </nav>

          {/* Mobile Menu Button */}
          <button type="button" className="md:hidden p-2 text-text hover:text-primary transition-colors" onClick={() => setMobileMenuOpen(!mobileMenuOpen)} aria-label={mobileMenuOpen ? 'Close menu' : 'Open menu'} data-id="element-44">
            {mobileMenuOpen ? <X className="w-6 h-6" data-id="element-45" /> : <Menu className="w-6 h-6" data-id="element-46" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden fixed inset-0 top-16 bg-[#F2F4F0] z-40" data-id="element-47">
          <nav className="flex flex-col items-center justify-center h-full gap-8 px-4" data-id="element-48">
            {navLinks.map(link => {
          const isActive = location.pathname === link.href;
          return <Link key={link.label} to={link.href} className={`font-sans text-2xl transition-colors ${isActive ? 'text-primary font-semibold' : 'text-text hover:text-primary'}`} onClick={() => setMobileMenuOpen(false)} data-id="element-49">
                  {link.label}
                </Link>;
        })}
          </nav>
        </div>}
    </header>;
}